'use es6';

import { createSelector } from 'reselect';
import { getEnableGoogleAmpOutputOverride } from './postContentModelSelectors';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
export const getAmp = basicSelector(state => state.amp);
export const getEnableGoogleAmpOutput = createSelector([getAmp], amp => amp.get('enableGoogleAmpOutput'));
export const getIsAmpEnabled = createSelector([getEnableGoogleAmpOutput, getEnableGoogleAmpOutputOverride], (enableGoogleAmpOutput, enableGoogleAmpOutputOverride) => enableGoogleAmpOutput || enableGoogleAmpOutputOverride);